import { helpers } from 'vuelidate/lib/validators';
/**
 * Validate value is empty
 * @param value
 * @returns {boolean}
 */
export function isEmpty(value) {
  if (typeof value === 'number') value = value.toString();

  return typeof value === 'undefined' || value === null || !value.length;
}

/**
 * Validate value is a number.
 * @param value
 * @returns {boolean}
 */
export function isNumber(value) {
  return typeof value === 'number';
}

/**
 * Validate positive number. (value is a number and >= 0)
 * @param value
 * @returns {boolean}
 */
export function isPositiveNumber(value) {
  if (typeof value === 'string') {
    const dotCount = (value.match(/\./g) || []).length;
    const dotStartString = value.charAt(0);
    const dotEndString = value.charAt(value.length - 1);

    if (dotStartString === '.') return false;
    if (dotEndString === '.') return false;
    if (dotCount > 1) return false;

    value = parseFloat(value);
  }

  return typeof value === 'number' && (value === 0 || value > 0);
}

/**
 * Validate positive integer number. (value is an integer and >0)
 * @param value
 * @returns {boolean}
 */
export function isPositiveInteger(value) {
  if (typeof value === 'string') value = parseFloat(value);

  return typeof value === 'number' && value > 0 && value === parseInt(value, 10);
}

/**
 * Validate limit number after dot in a decimal.
 * @param value
 * @param limit
 * @returns {boolean}
 */
export function isDecimalLimit(value, limit) {
  if (typeof value === 'string') value = parseFloat(value);

  return typeof value === 'number' && value >= 0 && parseFloat(value.toFixed(limit)) === value;
}

export function isValidEmail(email) {
  var re = /^[a-zA-Z0-9.!#$%&'*+/=?^_`{|}~-]+@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
  return re.test(email);
}

export function isImageFile(file) {
  const allowType = ['image/gif', 'image/jpeg', 'image/png'];
  return allowType.length ? allowType.indexOf(file.type) !== -1 : true;
}
/**
 * Validate max file size can upload in Mb)
 * @param size
 * @returns {boolean}
 */
export const maxFileSize = size => file => {
  return 0 < file.size / 1024 / 1024 && file.size / 1024 / 1024 < size;
};

// password rule
export const strictPassword = helpers.regex('strictPassword', /^([a-zA-Z0-9]{8,})$/);

export const positiveNumber = () => value => {
  return isPositiveNumber(value);
};

export const positiveInteger = () => value => {
  return isPositiveNumber(value) && value != 0;
};

export const decimalLimit = limit => value => {
  if (typeof value === 'string') value = parseFloat(value);
  return typeof value === 'number' && value >= 0 && parseFloat(value.toFixed(limit)) === value;
};

export const integerLimit = limit => value => {
  if (typeof value === 'string') value = parseFloat(value);
  return typeof value === 'number' && Math.pow(10, limit) >= value;
};

export const rangeLimit = limit => value => {
  value = value.toString();
  return value.length < parseInt(limit);
};

export function isCodeNumber(value) {
  return value.indexOf('_') < 0;
}
